<mat-toolbar class="fixed-footer-bar">
  <div class="row end-xs inner-content">
    <div class="col-xs start-xs" *ngIf="surveyProgress && isSurveyRoute()">
      <span class="survey-progress"><span [innerHTML]="'$survey_percentage_complete_label' | translate"></span>: {{ surveyProgress }}&#37;</span>
    </div>
  </div>
</mat-toolbar>
